export const GameGridFilterByEnum = Object.freeze({
    PROVIDERS: 'providers',
    THEMES: 'themes',
});
